import type { EventData } from 'services/Gtm/entities';

/** Visible heading for the article strip below the 404 message (App + Pages). */
export const NOT_FOUND_RECIRC_HEADING = 'Trending Stories' as const;

/**
 * GTM / analytics for 404 recirculation clicks (ArticleSectionRelated / LatestPopularContent cards).
 * Keep `contentPlacementCD` stable for reporting.
 */
export const NOT_FOUND_RECIRC_TRACKING: EventData = {
  contentPlacementCD: 'trending - 404',
  eventAction: 'trending module click',
  eventCategory: 'navigation',
};
